import { Rocket } from "lucide-react";
import { useTranslation } from "react-i18next";
import { ShineBorder } from "@/components/magicui/shine-border";

const MigrationBanner = () => {
  const { t } = useTranslation();

  return (
    <div className="fixed bottom-6 left-1/2 -translate-x-1/2 z-50 w-[calc(100%-3rem)] max-w-3xl animate-in slide-in-from-bottom-6 fade-in duration-500">
      <div className="relative overflow-hidden rounded-xl border border-blue-200 bg-gradient-to-r from-blue-50 via-white to-blue-50 px-6 py-5 shadow-2xl">
        <ShineBorder
          shineColor={["#3b82f6", "#8b5cf6", "#3b82f6"]}
          borderWidth={2}
          duration={10}
        />
        <div className="flex items-start gap-5">
          <div className="hidden sm:flex shrink-0 items-center justify-center h-12 w-12 rounded-full bg-blue-100 mt-0.5">
            <Rocket className="h-6 w-6 text-blue-600" />
          </div>
          <div className="flex-1 min-w-0">
            <p className="text-base font-semibold text-blue-900">
              {t("migrationBanner.title")}
            </p>
            <p className="text-sm text-blue-700 mt-1">
              {t("migrationBanner.description")}
            </p>
            <div className="mt-3 rounded-md bg-blue-100/70 px-3 py-2 text-sm text-blue-800">
              <p className="font-medium mb-1">{t("migrationBanner.stepsTitle")}</p>
              <ol className="list-decimal list-inside space-y-0.5 text-xs text-blue-700">
                <li>{t("migrationBanner.step1")}</li>
                <li>
                  {t("migrationBanner.step2")}{" "}
                  <code className="rounded bg-blue-200/60 px-1 py-0.5 text-[11px] font-mono">
                    odashboard.connection.url
                  </code>{" "}
                  → <code className="rounded bg-blue-200/60 px-1 py-0.5 text-[11px] font-mono">https://v1.odashboard.app</code>
                </li>
                <li>
                  {t("migrationBanner.step3")}{" "}
                  <code className="rounded bg-blue-200/60 px-1 py-0.5 text-xs font-mono">
                    odashboard.api.endpoint
                  </code>{" "}
                  → <code className="rounded bg-blue-200/60 px-1 py-0.5 text-[11px] font-mono">https://portal.osolutions.app</code>
                </li>
                <li>{t("migrationBanner.step4")}</li>
              </ol>
            </div>
            <p className="mt-2 text-xs text-blue-600 italic">
              {t("migrationBanner.v2Notice")}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MigrationBanner;
